<script setup lang="ts">
import { computed, reactive } from 'vue'

import { usePageStore } from '@toni/rendering/src/stores/page'

import { useAdPlacement } from '../advertisement/composables/use-ad-placement'
import ContentBlock from './components/ContentBlock.vue'
import { useContentBlockList } from './composables/use-content-block-list'

// Get page store for page meta information
const pageStore = usePageStore()
const adPlacement = useAdPlacement()

const paragraphs = computed(() => {
  const data = pageStore?.pageData?.body?.paragraphs
  return Array.isArray(data) ? data : []
})
const introductionText = computed(() => pageStore.pageData.body?.header?.introductionText)

// Define custom paragraph objects
const introductionTextParagraph = reactive({
  paragraphType: 'text',
  text: introductionText.value
})

// On overviewpages add introduction text paragraph before paragraphs in the array
const extendedParagraphs = computed(() => {
  return pageStore.pageData?.pageMeta?.pageType === 'structureterm'
    ? [
        ...(introductionTextParagraph?.text?.length ? [introductionTextParagraph] : []),
        ...paragraphs.value
      ]
    : paragraphs.value
})

// Get content blocks from the composable
const { contentBlocks } = useContentBlockList(extendedParagraphs.value, adPlacement.value)
</script>

<template>
  <ContentBlock v-for="block in contentBlocks"
                :id="block.id"
                :key="`${block.type}-${block.id}`"
                :type="block.type" />
</template>
